var render = function render(){var _vm=this,_c=_vm._self._c;return _c('audio',{attrs:{"src":require("@/assets/mp3/Tiempo_es_cerebro_Midazolam_Oromucosal.mp3"),"controls":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }